export default __webpack_public_path__ + "static/fXwYEEUA-b570febe9d96977515795be73e7bb057.svg";